/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

import { getTypographyByName } from "theme/typography";

export default function Breadcrumbs(theme: Theme): any {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: { marginLeft: theme.spacing(2), marginRight: theme.spacing(2) },
        li: {
          display: "inline-flex",
          margin: theme.spacing(0.25, 0),
          "& > *": { ...getTypographyByName(theme, "body2") },
        },
      },
    },
  };
}
